
angular.module('app')
    .directive('pieChart', function(){
        return {
            restrict: 'E',
            templateUrl: './pie-chart-template.html',
            scope: {
                pieChartData: '=',
                onUpdate : '='
            },
            controller: ['$scope', '$element', function($scope, $element){
                var pieChartData = $scope.pieChartData;

                window.___pies = [];
                window.___pcd = pieChartData;

                function doUpdate(t,itemIndex,parentIndex,data){

                    var pie = pieObject(t);
                    if(pie.fix){
                        //console.log(pie.audit);
                    }

                    function pieObject(t){
                        var pGroup =  $($('.pie-group')[parentIndex]),//$(t).parents('.pie-group'),
                            rInput = pGroup.find('div input[type="range"]'),
                            pItems = pGroup.find('.pie-item'),
                            rItems = pGroup.find('.range-item'),
                            o = {
                                rangeObj: t,
                                rangePctObj: [],
                                totalPctObj: pGroup.find('.total-percentage'),
                                total:0,
                                svgObj: [],
                                circlePctObj: [],
                                circleObj: [],
                                currentIndex: itemIndex,
                                rangeVal: [],
                                rangeInputObj: [],
                                circumference: [],
                                cumulativeTotal: [],
                                audit: '',
                                fix: false
                            };
                        rInput.each(function(i,rangeInput){
                            var _tempPercent = fixNumber($scope.pieChartData[parentIndex].val[i]);//fixNumber($(rangeInput).val());
                            o.total += Number(_tempPercent);
                            o.rangeVal[i] = _tempPercent;
                            o.cumulativeTotal[i] = o.total-o.rangeVal[i];
                            o.rangeInputObj[i] = rangeInput;
                            o.circlePctObj[i] = $(pItems[i]).find('div');
                            o.rangePctObj[i] = $(rItems[i]).find('div');
                            o.svgObj[i] = $(pItems[i]).find('svg');
                            o.circleObj[i] = $(pItems[i]).find('circle');
                            o.circumference[i] = o.circleObj[i].attr('r')*2*3.14159; //314;
                            o.audit += i+') '+o.rangeVal[i]+' ('+o.cumulativeTotal[i]+'), ';
                        });
                        o.audit += 'total) '+o.total;
                        o.fix = false;

                        // redraw
                        o.totalPctObj.html('Total: '+o.total+'%');
                        for(var i=0 ; i<o.rangeVal.length ; i++){
                            var arcLength = o.rangeVal[i]*o.circumference[i]/100;
                            o.circleObj[i].css('stroke-dasharray', arcLength + " " + o.circumference[i]);
                            o.circlePctObj[i].html(o.rangeVal[i]+'%').css({'display':'none'});
                            o.rangePctObj[i].html(o.rangeVal[i]+'%');
                        }

                        if(o.circlePctObj[o.currentIndex]){
                            o.circlePctObj[o.currentIndex].css({'display':'inline-block'});
                        }

                        if(o.currentIndex<o.rangeVal.length-1){
                            for(var i=o.currentIndex+1 ; i<o.rangeVal.length ; i++){
                                var turn = getTurnValue(o.cumulativeTotal[i]),
                                    deg = getDegValue(o.cumulativeTotal[i]);
                                // console.log(turn);
                                o.svgObj[i].css({
                                    '-moz-transform': 'rotate(' + deg + ')',
                                    '-o-transform': 'rotate(' + deg + ')',
                                    '-webkit-transform': 'rotate(' + deg + ')',
                                    'transform' : 'rotate(' + deg + ')'
                                });
                            }
                        }
                        window.___pies[parentIndex] = o;
                        return o;

                    } // END function pieObject(t){...

                    // get control of number precision for display
                    function fixNumber(n){
                        var _n=Number(n).toFixed(1), _l=4;
                        if(n<10){
                            _l=3;
                        }
                        if(n!=parseInt(n)){
                            _n=Number(n.toString().substr(0,_l))
                        }
                        return Number(_n);

                    } // END function fixNumber(n){...

                    // calculate
                    function getTurnValue(v){
                        var _v = parseInt(v)+75; /* +75 (or -25) place (original) 0% a the top not on the right */
                        if(_v>100) _v = _v-100;

                        if(_v<10){
                            return '.'+'0'.toString()+_v.toString()+'turn';
                        }
                        else if (_v ==100){
                            return '1turn'; // 1 = 100%
                        }
                        else{
                            return '.'+_v.toString()+'turn';
                        }

                    } // END function getTurnValue(v){...

                    function getDegValue(v){

                        var _v = parseInt(v)+75; /* +75 (or -25) place (original) 0% a the top not on the right */
                        if(_v>100) _v = _v-100;

                        var _d = parseInt(_v*3.6);
                        return _d.toString()+'deg'


                        // -moz-transform: rotate(45deg);  /* FF3.5/3.6 */
                        // -o-transform: rotate(45deg);  /* Opera 10.5 */
                        // -webkit-transform: rotate(45deg);  /* Saf3.1+ */
                        // transform: rotate(45deg);  /* Newer browsers (incl IE9) */

                    }

                    if($scope.onUpdate)
                        $scope.onUpdate(itemIndex);
                } // END function doUpdate(t){...

                $scope.updatePieGroup = function(data,i,p){
                    var rangeItem = $($('.pie-group')[p]).find('.range-item')[i],
                        t = $(rangeItem).find('input[type=range]'),
                        total = 0;
                    for(var j=0 ; j<data.val.length ; j++){
                        total += parseInt(pieChartData[p].val[j]);
                    }
                    //console.log('total '+total)
                    if(total > 100){
                        var _diff = total - 100;
                        pieChartData[p].val[i] -= _diff;
                        //console.log('pieChartData[p].val[i] '+pieChartData[p].val[i]+'   _diff '+_diff)
                    }
                    doUpdate(t,i,p)

                }; // END $scope.updatePieGroupAngular = function(data,i,p){...

                var initInterval = setInterval(function(){
                    if($('.pie-group')){
                        //console.log('-')
                        init();
                        clearInterval(initInterval);
                    }
                }, 1); // END initInterval... waiting for directive html to load

                (function(){
                    var d = $scope.pieChartData,
                        t = {};
                    for (var p = 0; p < d.length; p++) {
                        var maxWeight = _.max(d[p].val);
                        d[p].highestValueIndex = d[p].val.indexOf(maxWeight);
                        $scope.highestValueIndex =  d[p].highestValueIndex;
                        //console.log(d[p].highestValueIndex)
                    }
                })();

                function setPieStyle(params){ //[diameter,pie_font_size,stroke_width]
                    var _params = params || [130];
                    //console.log(params)
                    /*
                    * params[0] = pie diameter
                    * params[1] = pie font size
                    * params[2] = pie stroke width, the colored part of the pie
                    * */
                    var dia = parseInt(_params[0]) || 130,
                        pfs = parseInt(_params[1]) || Math.round(dia/5.4), // parseInt(pie_font_size)
                        sw  = parseInt(_params[2]) || Math.round(dia/6.8) // parseInt(stroke_width) || 14,

                    //console.log(dia,pfs,sw)


                    $('.pie-group').each(function(i,el){
                        var pie_group = this;

                        if($scope.pieChartData.length>1 && dia<=110){
                            $(this).css({
                                float:'left'
                                //'margin-left':'10px'
                            })
                            $(this).find('.pie-label').css({
                                'font-size': '12px',// '0.85em',
                                width:'100%',
                                'text-align':'center',
                                display:'inline-block',
                                padding:'10px 0 20px 0'

                            })
                            $('.result-pie-charts').css({
                                //height:'200px',
                                'padding-left':'15px',
                                'margin':'0 auto 10px'
                            })
                            //console.log( $('.result-pie-charts'))

                        }
                        $(this).find('svg.pie-chart, div.pie-position, div.pie-item').css({
                            width:dia.toString()+'px',
                            height:dia.toString()+'px'
                        });
                        $(this).find('svg.pie-chart').attr({
                            width:dia.toString()+"px",
                            height:dia.toString()+"px"
                        });
                        $(this).find('div.pie-text').css({
                            top:((dia/2)-(pfs/2)+1).toString()+"px",
                            left:(dia/4).toString()+"px",
                            width:(dia/2).toString()+"px",
                            'padding-left':'3px',
                            'font-size': pfs.toString()+"px",
                            'line-height': pfs.toString()+"px"
                        });
                        $(this).find('circle.pie')
                            .attr({
                                cx:parseInt(dia/2).toString(),
                                cy:parseInt(dia/2).toString(),
                                r:parseInt((dia/2)-(sw/2)).toString()
                            }).css({
                                'stroke-width':sw.toString()+"px"
                            });
                    })

                }

                function init(){

                    var d = $scope.pieChartData,
                        t = {};
                    for (var p = 0; p < d.length; p++) {

                        for (var i = 0; i < d[p].val.length && d[p].val[i]>-1 ; i++) {
                            var rangeItem =  $($('.pie-group')[p]).find('.range-item')[i],
                                t = $(rangeItem).find('input[type=range]');

                            doUpdate(t,i,p,d[p]);
                            setPieStyle(d[p].display)
                        }

                        var showHighestValue = d[p].showHighestValue || false;

                        if(showHighestValue){

                            var i = d[p].highestValueIndex || 0;
                            //console.log(i);
                            doUpdate(t,i,p,d[p])
                        }
                    }

                    // $('.pie-group').fadeIn(500);
                    $('.pie-group').show();

                } // END function init(){...

            }] // END controller: ['$scope', '$element', function($scope, $element){...

        } // NS return obj

    }); // END angular.module('app').directive('pieChart', function(){...

// END PIE CHART DIRECTIVE
